define(["language/resource","base/js/privacyUpdate/controllers/privacyUpdateController"],
    function(i18n, updateCtrl){
        "use strict";
        var privacyUpdateCtrl = function($scope){
            updateCtrl.call(this, $scope);

            // 隐私政策声明链接区分国内站和国际站
            $scope.model.privacyAgreement = window.ipIsInternational ? "https://intl.huaweicloud.com/" + window.language + "/declaration/sa_prp.html" : window.language === "zh-cn" ? "https://www.huaweicloud.com/declaration/sa_prp.html" : "https://www.huaweicloud.com/en-us/declaration/sa_prp.html";
            $scope.model.privacyAgreement = window.replaceDomain($scope.model.privacyAgreement);
        };
        var privacyUpdateModule = angular.module('authui.config');
        privacyUpdateCtrl = ['$scope', privacyUpdateCtrl];
        privacyUpdateModule.controller('authui.privacyUpdate.ctrl', privacyUpdateCtrl);
        return privacyUpdateCtrl;
    }
);


// WEBPACK FOOTER //
// ./public/hws/js/privacyUpdate/controllers/privacyUpdateController.js